<div>
  <p-tabs
    scrollable
    value="0"
    class="engagementDash"
    (onChange)="onTabChange($event)">
    <p-tablist>
      <p-tab value="0">Engagement Count</p-tab>
      <p-tab value="1">Customer Ack Approval</p-tab>
      <p-tab value="2">Finding Doc Review</p-tab>
      <p-tab value="3">Invoice Doc Review</p-tab>
      <p-tab value="4">Customer Survey Review</p-tab>
      <p-tab value="5">All Engagements</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        @if (isEngagmentCountSelected) {
          <app-engagement-count></app-engagement-count>
        }
      </p-tabpanel>
      <p-tabpanel value="1">
        <app-customer-acknowledgment-list></app-customer-acknowledgment-list>
      </p-tabpanel>
      <p-tabpanel value="2">
        <app-finding-doc-review-list></app-finding-doc-review-list>
      </p-tabpanel>
      <p-tabpanel value="3">
        <app-invoice-doc-review-list></app-invoice-doc-review-list>
      </p-tabpanel>
      <p-tabpanel value="4">
        <app-customer-survey-review-list></app-customer-survey-review-list>
      </p-tabpanel>
      <p-tabpanel value="5">
        <app-all-engagement-list></app-all-engagement-list>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
